import { useEffect, useState } from 'react'
import { BooksitoutServer } from '../../../config/BooksitoutServer'

// Only a 2~4 letter Korean name is prefilled (nicknames and English names are left for the user to type)
const KOREAN_NAME = /^[가-힣]{2,4}$/

export const toOwnerNamePrefill = (accountName?: string | null): string | null => {
	const trimmed = accountName?.trim()
	return trimmed && KOREAN_NAME.test(trimmed) ? trimmed : null
}

// Name from sign-in (personal-info), not the public nickname from /settings/profile
const useOwnerNamePrefill = (): string | null => {
	const [prefill, setPrefill] = useState<string | null>(null)

	useEffect(() => {
		BooksitoutServer.get('/v1/users/settings/personal-info')
			.then(res => setPrefill(toOwnerNamePrefill(res.data?.name)))
			.catch(() => {})
	}, [])

	return prefill
}

export default useOwnerNamePrefill
